//frontend/dispatcher-client/src/api/personnelApi.js
import api from "../axiosConfig";

/* =========================================================
 * PEOPLE
 * ======================================================= */

export async function fetchPersonnelPeople({
  signal,
} = {}) {
  const { data } =
    await api.get(
      "/personnel/people",
      {
        signal,
      }
    );

  return Array.isArray(
    data?.people
  )
    ? data.people
    : [];
}

/* =========================================================
 * ABSENCES
 * ======================================================= */

export async function fetchPersonnelAbsences(
  params = {},
  {
    signal,
  } = {}
) {
  const { data } =
    await api.get(
      "/personnel/absences",
      {
        params,
        signal,
      }
    );

  return Array.isArray(
    data?.absences
  )
    ? data.absences
    : [];
}

export async function fetchPersonnelAbsence(
  id,
  {
    signal,
  } = {}
) {
  const { data } =
    await api.get(
      `/personnel/absences/${id}`,
      {
        signal,
      }
    );

  return (
    data?.absence ||
    null
  );
}

export async function fetchPersonnelAbsenceAudit(
  id,
  {
    signal,
  } = {}
) {
  const { data } =
    await api.get(
      `/personnel/absences/${id}/audit`,
      {
        signal,
      }
    );

  return Array.isArray(
    data?.history
  )
    ? data.history
    : [];
}

export async function createPersonnelAbsence(
  payload
) {
  const { data } =
    await api.post(
      "/personnel/absences",
      payload
    );

  return (
    data?.absence ||
    null
  );
}

export async function updatePersonnelAbsence(
  id,
  payload
) {
  const { data } =
    await api.patch(
      `/personnel/absences/${id}`,
      payload
    );

  return (
    data?.absence ||
    null
  );
}

export async function approvePersonnelAbsence(
  id
) {
  const { data } =
    await api.post(
      `/personnel/absences/${id}/approve`
    );

  return (
    data?.absence ||
    null
  );
}

export async function rejectPersonnelAbsence(
  id
) {
  const { data } =
    await api.post(
      `/personnel/absences/${id}/reject`
    );

  return (
    data?.absence ||
    null
  );
}

export async function cancelPersonnelAbsence(
  id
) {
  const { data } =
    await api.post(
      `/personnel/absences/${id}/cancel`
    );

  return (
    data?.absence ||
    null
  );
}

export async function deletePersonnelAbsence(
  id
) {
  const { data } =
    await api.delete(
      `/personnel/absences/${id}`
    );

  return data;
}

/* =========================================================
 * PUBLIC HOLIDAYS
 * ======================================================= */

export async function fetchPersonnelPublicHolidays(
  params = {},
  {
    signal,
  } = {}
) {
  const { data } =
    await api.get(
      "/personnel/public-holidays",
      {
        params,
        signal,
      }
    );

  return Array.isArray(
    data?.publicHolidays
  )
    ? data.publicHolidays
    : [];
}

export async function createPersonnelPublicHoliday(
  payload
) {
  const { data } =
    await api.post(
      "/personnel/public-holidays",
      payload
    );

  return (
    data?.publicHoliday ||
    null
  );
}

export async function updatePersonnelPublicHoliday(
  id,
  payload
) {
  const { data } =
    await api.patch(
      `/personnel/public-holidays/${id}`,
      payload
    );

  return (
    data?.publicHoliday ||
    null
  );
}

export async function deletePersonnelPublicHoliday(
  id
) {
  const { data } =
    await api.delete(
      `/personnel/public-holidays/${id}`
    );

  return data;
}

/* =========================================================
 * HOLIDAY WORK
 * ======================================================= */

export async function fetchPersonnelHolidayWork(
  params = {},
  {
    signal,
  } = {}
) {
  const { data } =
    await api.get(
      "/personnel/holiday-work",
      {
        params,
        signal,
      }
    );

  return Array.isArray(
    data?.holidayWork
  )
    ? data.holidayWork
    : [];
}

export async function fetchPersonnelHolidayWorkItem(
  id,
  {
    signal,
  } = {}
) {
  const { data } =
    await api.get(
      `/personnel/holiday-work/${id}`,
      {
        signal,
      }
    );

  return (
    data?.holidayWork ||
    null
  );
}

export async function createPersonnelHolidayWork(
  payload
) {
  const { data } =
    await api.post(
      "/personnel/holiday-work",
      payload
    );

  return (
    data?.holidayWork ||
    null
  );
}

export async function createPersonnelHolidayWorkBulk(
  payload
) {
  const { data } =
    await api.post(
      "/personnel/holiday-work/bulk",
      payload
    );

  return Array.isArray(
    data?.holidayWork
  )
    ? data.holidayWork
    : [];
}

export async function updatePersonnelHolidayWork(
  id,
  payload
) {
  const { data } =
    await api.patch(
      `/personnel/holiday-work/${id}`,
      payload
    );

  return (
    data?.holidayWork ||
    null
  );
}

export async function confirmPersonnelHolidayWork(
  id
) {
  const { data } =
    await api.post(
      `/personnel/holiday-work/${id}/confirm`
    );

  return (
    data?.holidayWork ||
    null
  );
}

export async function deletePersonnelHolidayWork(
  id
) {
  const { data } =
    await api.delete(
      `/personnel/holiday-work/${id}`
    );

  return data;
}

/* =========================================================
 * WORK DAYS
 * ======================================================= */

export async function fetchPersonnelWorkDays(
  params = {},
  {
    signal,
  } = {}
) {
  const {
    data,
  } =
    await api.get(
      "/personnel/work-days",
      {
        params,
        signal,
      }
    );

  return Array.isArray(
    data?.workDays
  )
    ? data.workDays
    : [];
}

export async function createPersonnelWorkDay(
  payload
) {
  const {
    data,
  } =
    await api.post(
      "/personnel/work-days",
      payload
    );

  return (
    data?.workDay ||
    null
  );
}

export async function applyPersonnelWorkDaysBulk(
  payload
) {
  const {
    data,
  } =
    await api.post(
      "/personnel/work-days/bulk",
      payload
    );

  return {
    workDays:
      Array.isArray(
        data?.workDays
      )
        ? data.workDays
        : [],

    affectedCount:
      Number(
        data?.affectedCount ||
          0
      ),

    personCount:
      Number(
        data?.personCount ||
          0
      ),

    dayCount:
      Number(
        data?.dayCount ||
          0
      ),
  };
}

export async function updatePersonnelWorkDay(
  id,
  payload
) {
  const {
    data,
  } =
    await api.patch(
      `/personnel/work-days/${id}`,
      payload
    );

  return (
    data?.workDay ||
    null
  );
}

export async function deletePersonnelWorkDay(
  id
) {
  const {
    data,
  } =
    await api.delete(
      `/personnel/work-days/${id}`
    );

  return data;
}